import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";
import ImageGallery from "../components/ImageGallery";

function DguTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/acoustic-windows-doors">
        Overview
      </NavLink>
      <NavLink to="/acoustic-windows-doors/specifications">
        Specifications
      </NavLink>
      <NavLink to="/acoustic-windows-doors/projects">
        Projects
      </NavLink>
    </div>
  );
}

/* ---------- OVERVIEW ---------- */

function DguWindowsOverview() {
  return (
    <div className="page">
      <PageHero
        title="DGU Windows"
        subtitle="Double glazed window systems for energy efficiency, acoustic comfort and premium aesthetics."
        imagePlaceholder="DGU Window Systems"
      />
      <DguTabs />

      <section className="section">
        <h2>Applications</h2>
        <div className="two-column">
          <ul className="list">
            <li>Corporate and commercial façades</li>
            <li>Control rooms & studios</li>
            <li>Residential & hospitality projects</li>
            <li>Noise-sensitive industrial buildings</li>
          </ul>
          <p className="muted">
            DGU windows improve thermal performance and sound insulation while
            maintaining clear, modern façades. Systems can be integrated with
            panel cladding, curtain walling and interior partitions.
          </p>
        </div>
      </section>
    </div>
  );
}

/* ---------- SPECIFICATIONS ---------- */

export function DguWindowsSpecs() {
  return (
    <div className="page">
      <PageHero
        title="DGU Windows – Specifications"
        subtitle="Typical glass make-ups, cavity configuration and frame options."
        imagePlaceholder="Glass Section Details"
      />
      <DguTabs />

      <section className="section">
        <h2>System Highlights</h2>
        <div className="spec-grid">
          <div>
            <h3>Glass Types</h3>
            <p>
              Clear, tinted, reflective, Low-E, laminated or acoustic glass
              combinations based on performance needs.
            </p>
          </div>
          <div>
            <h3>Spacer & Cavity</h3>
            <p>
              Optimised cavity width with warm-edge spacers and desiccants for
              long-term condensation control.
            </p>
          </div>
          <div>
            <h3>Frame Options</h3>
            <p>
              Thermally broken aluminium or uPVC frames with openable, sliding
              and fixed configurations.
            </p>
          </div>
          <div>
            <h3>Performance</h3>
            <p>
              Configurable U-values and STC / dB ratings to meet façade and
              acoustic requirements.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ---------- PROJECTS ---------- */

export function DguWindowsProjects() {
  const galleryItems = [
    { label: "Office Facade" },
    { label: "Corner Glazing" },
    { label: "Studio Window" },
    { label: "Residential Bay" },
    { label: "Sliding System" }
  ];

  return (
    <div className="page">
      <PageHero
        title="DGU Windows – Projects"
        subtitle="Installed across commercial façades, studios and premium homes."
        imagePlaceholder="Installed DGU Systems"
      />
      <DguTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Corporate Facade</h3>
            <p>
              Curtain wall with DGU units to reduce solar heat gain and improve
              indoor comfort.
            </p>
          </div>
          <div className="card">
            <h3>Recording Studio</h3>
            <p>
              High-STC double-glazed windows between control and live rooms for
              isolation.
            </p>
          </div>
          <div className="card">
            <h3>Premium Residence</h3>
            <p>
              Sliding and fixed DGU windows facing busy streets to cut traffic
              noise.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Click a façade or window configuration to preview it in a larger view.
        </p>

        <ImageGallery items={galleryItems} />
      </section>
    </div>
  );
}

export default DguWindowsOverview;
